"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendNotificationClickEvent = exports.getNotificationEventTypeName = void 0;
var _1 = require(".");
var NOTIFICATION_TYPE_EVENT_MAP = {
    follow: "new_followers",
    vote: "votes",
    message: {
        default: "profile_posts",
        replies: "replies",
        mentions: "mentions",
        broadcast: "announcements",
    },
    comment: {
        default: "comments",
        replies: "replies",
        mentions: "mentions",
    },
    inline_comment: {
        default: "comments",
        replies: "replies",
        mentions: "mentions",
    },
    dedicate: "dedications",
    library: "reading_list_adds",
    upload: "story_updates",
    generic: "generic"
};
/**
 * Certain usecases have event sub types. This helper is used by getNotificationEventTypeName to drill down deeper
 * to get the event sub type name where applicable.
 * @returns eventName
 */
var getNotificationEventSubType = function (_a) {
    var type = _a.type, hasMentions = _a.hasMentions, wasBroadcast = _a.wasBroadcast, hasReplies = _a.hasReplies;
    var eventName;
    // For notification type 'comment', 'inline_comment', and 'message'
    if (hasMentions) {
        eventName = NOTIFICATION_TYPE_EVENT_MAP[type].mentions;
    }
    else if (wasBroadcast) {
        eventName = NOTIFICATION_TYPE_EVENT_MAP[type].broadcast;
    }
    else if (hasReplies) {
        eventName = NOTIFICATION_TYPE_EVENT_MAP[type].replies;
    }
    else {
        eventName = NOTIFICATION_TYPE_EVENT_MAP[type].default;
    }
    return eventName;
};
/**
 * Helper function to get the correct event name based on some context of a notification.
 * @returns eventName
 */
var getNotificationEventTypeName = function (_a) {
    var type = _a.type, hasMentions = _a.hasMentions, wasBroadcast = _a.wasBroadcast, hasReplies = _a.hasReplies;
    var eventName;
    if (typeof NOTIFICATION_TYPE_EVENT_MAP[type] === "string") {
        eventName = NOTIFICATION_TYPE_EVENT_MAP[type];
    }
    else {
        eventName = getNotificationEventSubType({
            type: type,
            hasMentions: hasMentions,
            wasBroadcast: wasBroadcast,
            hasReplies: hasReplies,
        });
    }
    return eventName;
};
exports.getNotificationEventTypeName = getNotificationEventTypeName;
/**
 * Sends an event that a user has interacted with one of their notifications
 * (excluding aggregate and any other secondary interaction).
 * Event name: "${PLATFORM}:notifications_feed:item::click"
 */
var sendNotificationClickEvent = function (_a) {
    var page = _a.page, section = _a.section, element = _a.element, eventDetails = _a.eventDetails;
    if (!eventDetails.username) {
        eventDetails.username = null;
    }
    if (!eventDetails.storyid) {
        eventDetails.storyid = null;
    }
    if (!eventDetails.reading_listid) {
        eventDetails.reading_listid = null;
    }
    if (!eventDetails.generic) {
        eventDetails.generic = null;
    }
    (0, _1.sendEvent)(page, section, element, "click", eventDetails);
};
exports.sendNotificationClickEvent = sendNotificationClickEvent;
